import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ReactComponent as DDxEdit } from "../../../assets/images/ddx-edit.svg";

interface PatientTextInputProps {
  text: string;
  disabled?: boolean;
  onPressEdit: () => void;
  isDDxGenerated?: boolean;
}

const PatientTextInput: React.FC<PatientTextInputProps> = ({
  text,
  disabled = false,
  onPressEdit,
  isDDxGenerated = false,
}) => {
  return (
    <div className={`${disabled && "opacity-50 pointer-events-none"}`}>
      <AnimatePresence mode="wait">
        <motion.div
          key={`answered`}
          initial={{
            opacity: 0,
            scale: 0.5,
            transformOrigin: "top right",
          }}
          animate={{ opacity: 1, scale: 1, transformOrigin: "top right" }}
          exit={{ opacity: 0, scale: 0.5, transformOrigin: "top right" }}
          transition={{ duration: 0.2 }}
          className="flex flex-row items-end gap-2.5 my-7 justify-end"
        >
          <button
            onClick={() => {
              onPressEdit();
            }}
            className="mb-3"
          >
            <DDxEdit className="min-h-6 min-w-6" />
          </button>
          <div className="relative">
            <div className="relative bg-white z-10 rounded-l-[18px] rounded-tr-[18px] shadow-[0px_0px_12px_0px_#A238FF0D] p-3.5 flex flex-col gap-4">
              <p className="text-sm text-left leading-5 text-gray-800 font-normal">
                {text}
              </p>
            </div>
            {isDDxGenerated && (
              <div className="relative bg-[#FDF7D7] z-0 pt-[26px] -mt-4 pb-2.5 px-3 rounded-b-[18px]">
                <p className="font-normal text-left text-xs text-[#ED8A00]">
                  <span className="font-semibold">Note:</span> To generate more
                  accurate DDx results, refine your prompt by editing it.
                </p>
              </div>
            )}
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default PatientTextInput;
